module.exports = __webpack_public_path__ + "static/media/uf_logo.e649a153.png";